module.exports = __webpack_public_path__ + "images/login_logo.e2bd.png";